export class QueryParamsModel {
	// fields
    search: string;
	pageNumber: number;
	pageSize: number;
	sortOrder?:string; // asc || desc
	sortField?:string;

	// constructor overrides
	constructor(
		_filter: string,
		_pageNumber: number = 0,
		_pageSize: number = 10,_sortOrder = 'asc',_sortField = '') {
		this.search = _filter;
		this.pageNumber = _pageNumber;
		this.pageSize = _pageSize;
		this.sortOrder = _sortOrder;
		this.sortField = _sortField;
	}
}
